module.exports = new __parcel__URL__("products-logo.26cd2865.png").toString();